import { CheckboxProps, Checkbox as CheckboxAntD } from 'antd';
import { FC } from 'react';

export const Checkbox: FC<CheckboxProps> = (props) => {
	return <CheckboxAntD {...props} />;
};
